import { motion, useReducedMotion } from 'motion/react'
import { conceptPoints } from '../content/site'
import { Reveal } from './Reveal'
import { SectionLabel } from './SectionLabel'

export function Concept() {
  const reduceMotion = useReducedMotion()

  return (
    <section className="section concept-section" id="concept">
      <div className="shell concept-layout">
        <div className="concept-topline">
          <SectionLabel number="02" label="Concept" />
          <span className="concept-code" aria-hidden="true">B/02</span>
        </div>
        <Reveal className="concept-headline">
          <p className="section-kicker">Retail concept</p>
          <h2>
            Built for the way mall shoppers buy <span>mobile accessories.</span>
          </h2>
        </Reveal>
        <div className="concept-bottom">
          <Reveal className="concept-body">
            <p>
              The proposed kiosk brings commonly needed phone accessories into a compact retail format with clear product grouping, quick browsing and a visible mall-floor presence.
            </p>
          </Reveal>
          <motion.div
            className="concept-points"
            initial={reduceMotion ? false : 'hidden'}
            whileInView="show"
            viewport={{ once: true, amount: 0.3 }}
            variants={{
              hidden: {},
              show: { transition: { staggerChildren: 0.08 } },
            }}
          >
            {conceptPoints.map((item) => (
              <motion.div
                className="concept-point"
                key={item.number}
                variants={{
                  hidden: { opacity: 0, y: 16 },
                  show: { opacity: 1, y: 0, transition: { duration: 0.52, ease: [0.22, 1, 0.36, 1] } },
                }}
              >
                <span>{item.number}</span>
                <div>
                  <strong>{item.title}</strong>
                  <p>{item.body}</p>
                </div>
              </motion.div>
            ))}
          </motion.div>
        </div>
      </div>
    </section>
  )
}
